const NODE_PROD = 'production'
const SPRING_PROD = 'prod'

/**
 * Boolean que indica se a coleta de métricas deve ser habilitada.
 * Deve ser true apenas para servidores de `prod` e `staging`
 */
export const METRICS_ENABLED =
  process.env.NODE_ENV === NODE_PROD &&
  (process.env.REACT_APP_SPRING_PROFILES_ACTIVE || '').split(',').indexOf('dev') === -1

export function isProd(): boolean {
  const profilesAtivos = (process.env.REACT_APP_SPRING_PROFILES_ACTIVE ?? '').split(',')
  return process.env.NODE_ENV === NODE_PROD && profilesAtivos.includes(SPRING_PROD)
}
